import axios from "axios";
import 'dotenv/config'
const url = process.env.VUE_APP_URL;
const key = process.env.VUE_APP_KEY;
// console.log('key',key)
// console.log('url',url)
const apiClient = axios.create();

// Add a request interceptor
apiClient.interceptors.request.use( (config)=> {
  // Do something before request is sent
  config.baseURL = url
 
    // const token = localStorage.getItem("access_token");

    // if(token)
    // {
      // config.headers.Authorization = `Bearer ${token}`;
      config.headers['x-api-key'] = key
    // }
   

  return config;
}, (error) => {
  // Do something with request error
  console.log('error',error)
  return Promise.reject(error);
});

  apiClient.interceptors.response.use( (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // Desenvuelve el formato estándar del backend { success, message, data }
    // para que res.data siga siendo el payload original del endpoint.
    const body = response.data;
    if (
      body !== null &&
      typeof body === "object" &&
      !Array.isArray(body) &&
      !(body instanceof Blob) &&
      typeof body.success === "boolean" &&
      "message" in body &&
      "data" in body
    ) {
      response.data = body.data;
    }
    return response;
  }, (error) => {
    // Copia el `message` del backend ({ success: false, message }) a error.message
    const body = error?.response?.data;
    if (body && typeof body === "object" && typeof body.message === "string") {
      error.message = body.message;
    }
  
    console.log('ups error ',error)
    // alert('error')
    // if(error.response.status === 404 || error.response.status === 401 ) // el 404 se removio por causa de la imagen del instituto
    if( error?.response?.status === 401 )  //solo si no esta autorizado
    {
      console.log('close sesion')
      window.location.href = '/'
      localStorage.clear();
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  })


// }

export default apiClient;
